export default class CustomProperties {
    static customProperties = undefined;

    static setCustomProperties(customProperties) {
        CustomProperties.customProperties = customProperties;
    }

    static install(Vue) {
        Vue.prototype.$getCustomProperty = function(key) {
            if (CustomProperties.customProperties && CustomProperties.customProperties[key]) {
                return CustomProperties.customProperties[key];
            } else {
                return undefined;
            }
        };
    }
}
